import { ShopStock } from "@hermes/api-model-shop";

export interface ProductLocatorState {
    status: "uninitialized" | "loaded" | "loading" | "error";
    shopsStock: ShopStockRecord;
    error: string | undefined;
}

export type ShopStockRecord = Record<string, ShopStock>;

export const initialProductLocatorState: ProductLocatorState = {
    status: "uninitialized",
    shopsStock: {},
    error: undefined,
};
